/**
 * Sayings in Hinglish (Hindi typed in Latin letters, as on WhatsApp) for the meaning router (ADR 0042), which had two
 * or three per intent and named 42% of Hinglish messages right. Spelling varies on purpose (kitna/kitnaa, chahiye/
 * chaiye); near-misses teach the edges: work already done is chat, a fair-price question is market. Never copied from
 * vectors/intents (word overlap under 0.6 with every case).
 */
export const HINGLISH_SAYINGS = {
    editCard: [
        "bhai mera rate 800 karna hai",
        "card pe telugu bhi add kar do plz",
        "mera minimum charge 350 rakh do",
        "ab Koramangala side kaam nai karta wo area hata do",
        "card me likh do ki ac repair bhi karta hu",
        "rate thoda badhana h card pe",
        "mere bare me jo likha h card pe wo change karna hai",
        "Whitefield bhi daal do mere area me",
    ],
    helpOffer: [
        "jo log naye aaye h unki help kar dunga",
        "bhai main mentor ban sakta hu kya",
        "gaon se koi naya aaye to mujhe batao main sambhal lunga",
        "naye bando ko settle hone me madad karni h mujhe",
        "mera naam helper list me daal do",
        "jo naya aaya ho shehar me usko rasta dikha dungi",
        "naye logo ko guide karne ke liye main ready hu",
        "mentor wala kaam karna chahti hu",
    ],
    helpStop: [
        "ab mentor nai rehna",
        "mujhe helpers wali suchi me se remove karo plz",
        "naye logo ki madad ab nahi ho payegi time nai h",
        "naye aane walo ka phone ab mere paas na aaye",
        "mentorship chhodni h mujhe",
        "ab newcomers ko guide nai karunga",
        "abhi bahut busy hu help wala off kar do",
        "mujhe mentor se hatao yaar",
    ],
    moving: [
        "agle mahine Pune ja raha hu kaam ke liye",
        "bhai main Bangalore shift ho rahi hu job mili h",
        "kaam ke chakkar me Chennai jaana padega mujhe",
        "hum dono naye sheher ja rahe h kaam dhundhne",
        "Delhi chhod ke Bengaluru aa raha hu next week",
        "mujhe Hyderabad me kaam mila h wahi shift hona h",
        "main gaon se sheher aa rahi hu kaam ke liye",
        "Mumbai relocate karna h mujhe naukri ke liye",
    ],
    earnings: [
        "7 din me mere haath kitna aaya",
        "bhai mera total kitna hua ab tak",
        "kis kis ne mera paisa nai diya abhi tak",
        "october me meri kul income kitni bani",
        "mera kitna baaki h logo pe",
        "aaj tak kitne paise aaye mere",
        "Sharma ji wale ghar se kitna mila mujhe",
        "is month ki meri income dikhao plz",
    ],
    schedule: [
        "parso subah 8 se 10 Gupta ji ke ghar ka kaam note karo schedule mein",
        "mangal ko 3 baje se 5 baje tak booking hai",
        "meri kal ki bookings kya hain",
        "mera schedule dikhao aage kaunsi booking hai",
        "budh wali booking radd kar do",
    ],
    market: [
        "cook ko 8000 dena sahi h kya",
        "bhai electrician kitna leta h ek visit ka",
        "HSR me maid ka rate kitnaa chal raha h",
        "driver ki salary kitni honi chahiye",
        "painter 2 room ke 6000 bol raha h zyada h kya",
        "main cooking ke 12000 maang rahi hu zyada to nai",
        "babysitter ko mahine ka kitna dete h log",
        "carpenter ka per day kya rate h aajkal",
    ],
    guide: [
        "yaha sasta room kaha milega",
        "bank account kholne ke liye kya kya chahiye",
        "naya sim lena h aadhar se ho jayega kya",
        "kaam pe jaane ke liye bus kaise pakdu yaha",
        "PG ka rent kitna hota h is area me",
        "ration card yaha transfer kaise hoga",
        "metro card kaha banta h",
        "rehne ke liye koi safe jagah batao bhai",
    ],
    find: [
        "bhai kal subah ek plumber bhej do",
        "kitchen ka nal tapak raha h",
        "ghar ke liye full time maid chaiye",
        "fan nai chal raha koi bulao",
        "khana banane wali chahiye 2 time ke liye",
        "deewar pe paint karwana h",
        "bacche ko sambhalne ke liye koi mil jayega kya",
        "ek room ki light nai jal rahi electrician chaiye",
    ],
    remember: [
        "yaad rakhna Gupta ji 10 tareekh ko paise denge",
        "note kar lo kal 8 baje pahunchna h",
        "likh lo teesri manzil wali aunty ko jain khana chahiye",
        "ye yaad rakh lo sunday ko chutti h",
        "note karo Verma ji ne 500 advance diya",
        "ek baat likh lo naya client 2nd floor pe h",
        "yaad rakhna drill machine Imran ke paas h",
        "save kar lo ye baat ki bhaiya monday nahi aayenge",
    ],
    askSelf: [
        "Gupta ji ke bare me maine kya likha tha",
        "advance wali baat note me h kya",
        "maine sunday ke liye kya note kiya tha",
        "bhai mera note dikhao naye client wala",
        "kya maine likha tha ki kab pahunchna h",
        "notes me kahi likha h kya ki plumber kaun tha",
        "chhutti ke din wala note padh ke sunao",
        "meri notes me kya kya h",
    ],
    askContact: [
        "Ravi se puch kal free h kya",
        "Seema kaha h abhi",
        "Sunil bhai se pucho aaj aa sakta h kya",
        "Meera ko koi accha plumber pata h kya puchna",
        "Raju ne kaam khatam kiya kya",
        "Manju se puchho Sunday ko aayegi",
        "Deepak ki tabiyat kaisi h puch lo",
        "Seema ko message karo kitne baje aayegi",
    ],
    setRule: [
        "Ravi meri jagah track kar sakta h allow h",
        "Seema ko mera address mat batana",
        "Sunil meri kamai nahi dekh sakta",
        "Meera mujhse timing puch sakti h koi dikkat nai",
        "Raju ko ab se mera schedule dikhana band karo",
        "Manju ko mere notes dekhne ki permission de do",
        "Deepak kuch bhi puche mere bare me to batana mat",
        "Pooja ko mera rate pata chal sakta h",
    ],
    chat: [
        "bhai kaise ho",
        "thank u bhai",
        "aaj 4 ghar ka kaam kar liya",
        "kal Sharma ji ko 700 de diya",
        "mera bhai Pune shift ho raha h",
        "aaj bahut garmi h yaar",
        "Ravi ne bataya uski shaadi h next month",
        "kal plumber aaya tha kaam ho gaya",
    ],
};
//# sourceMappingURL=sayings-hinglish.js.map